import { EUserRole } from '@okcargo-apps/shared-domain';

export interface IUserFormValue {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  enabled: boolean;
  roles: EUserRole[];
}

export interface IUserRoleOption {
  role: EUserRole;
  labelKey: string;
}

/** Object id used by the messages-ui service to show messages about the users list. */
export const USERS_LIST_MESSAGE_OBJECT_ID = 'users-list';

export const USER_ROLE_OPTIONS: readonly IUserRoleOption[] = [
  { role: EUserRole.DRIVER, labelKey: 'users.roles.driver' },
  { role: EUserRole.CARRIER_ADMIN, labelKey: 'users.roles.carrier_admin' },
  { role: EUserRole.SHIPPER_ADMIN, labelKey: 'users.roles.shipper_admin' },
  { role: EUserRole.CREATE_DECA_AS_CARRIER, labelKey: 'users.roles.create_deca_as_carrier' },
  { role: EUserRole.CREATE_DECA_AS_SHIPPER, labelKey: 'users.roles.create_deca_as_shipper' },
  { role: EUserRole.DECA_DRIVER, labelKey: 'users.roles.deca_driver' },
];
